export const defaultResponsiveDashboardLayout = {
  lg: [
    {
      w: 6,
      h: 6,
      x: 0,
      y: 0,
      i: "1",
      minW: 2,
      minH: 3,
      moved: false,
      static: false,
    },
    {
      w: 6,
      h: 6,
      x: 6,
      y: 0,
      i: "2",
      minW: 2,
      minH: 3,
      moved: false,
      static: false,
    },
    {
      w: 6,
      h: 6,
      x: 0,
      y: 6,
      i: "3",
      minW: 2,
      minH: 3,
      moved: false,
      static: false,
    },
    {
      w: 6,
      h: 6,
      x: 6,
      y: 6,
      i: "4",
      minW: 2,
      minH: 3,
      moved: false,
      static: false,
    },
    {
      w: 6,
      h: 6,
      x: 0,
      y: 12,
      i: "5",
      minW: 2,
      minH: 3,
      moved: false,
      static: false,
    },
    {
      w: 6,
      h: 6,
      x: 6,
      y: 12,
      i: "6",
      minW: 2,
      minH: 3,
      moved: false,
      static: false,
    },
    {
      w: 6,
      h: 6,
      x: 0,
      y: 18,
      i: "7",
      minW: 2,
      minH: 3,
      moved: false,
      static: false,
    },
    {
      w: 6,
      h: 6,
      x: 6,
      y: 18,
      i: "8",
      minW: 2,
      minH: 3,
      moved: false,
      static: false,
    },
  ],
};
